// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-4ee621d5]{align-items:center;display:flex;height:100vh;justify-content:center;width:100%}.error-page .text[data-v-4ee621d5]{color:#f24949;font-size:25px;font-weight:700;line-height:40px;text-align:center;width:90%}@media(min-width:768px){.error-page .text[data-v-4ee621d5]{font-size:35px;line-height:50px;width:60%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
